import * as actionTypes from "../constants/authContants";

export const authReducer = (state = { authData: null }, action) => {
  switch (action.type) {
    case actionTypes.AUTH:
      localStorage.setItem("profile", JSON.stringify({ ...action?.data }));
      return { ...state, authData: action.data, loading: false, errors: null };
    case actionTypes.LOGOUT:
      localStorage.clear();
      window.location.reload(true);
      return { ...state, authData: null, loading: false, errors: null };
    default:
      return state;
  }
};
